// colors.ts

export const colors = {
    primary: {
        darkBlue: "#24347D",
        teal: "#26A2AB",

        // Extra shades you added
        teal1: "#2dd4bf",
        darkBlue1: "#1e3a8a",
    },

    secondary: {
        lightBlue: "#6D92B3",
        paleAqua: "#B2D1DB",
    },

    neutral: {
        white: "#FDFDFD",
    },

    gradient: {
        // Clean reusable gradient (brand)
        brand: "linear-gradient(90deg, #24347D, #26A2AB, #6D92B3)",

        // Gradient using your extra shades
        soft:
            "linear-gradient(90deg, #1e3a8a22, #2dd4bf22, #1e3a8a22)",

        // Stronger version
        strong:
            "linear-gradient(90deg, #1e3a8a, #2dd4bf, #24347D)",
    }
} as const;